import React, { useState } from 'react';
import { IconButton, Tooltip, Popover, Typography, Box } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

const InfoPopover = () => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <Box>
      <Tooltip title="More Information">
        <IconButton aria-describedby={id} onClick={handleClick}>
          <InfoIcon sx={{ color: 'white' }} fontSize="large" />
        </IconButton>
      </Tooltip>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Box sx={{ p: 2, maxWidth: 300 }}>
          <Typography variant="body1" gutterBottom>
            Enter an English Premier League club name in the input box below.
            Press Enter or Submit to make a guess.
          </Typography>
        </Box>
      </Popover>
    </Box>
  );
};

export default InfoPopover;
